module.exports = __webpack_public_path__ + "media/003.7f8b2cf4.mp3";